import _ from 'lodash'

export default {
    getActiveComponentModeIds(activeModes, compModeDefinitions): Record<string, boolean> {
        return _(activeModes)
            .mapValues((modeData, modeId) => _.some(compModeDefinitions, {modeId}))
            .pickBy()
            .value()
    }
}
